// extracted by mini-css-extract-plugin
module.exports = {"SVGCard":"styles_SVGCard__1Cr0x","fadeIn":"styles_fadeIn__3NPkO"};